import React, { Fragment, useState } from 'react';
import walkinImg from '../../../images/logoWithText.jpeg';
import './index.css';
import { Col, Row, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import {forgotPassword} from '../../../constants/apiCalls';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import { messages } from '../../../utils/constant-messages';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';

const ForgotPassword = () => {
  const [isLoading, setIsloading] = useState(false);
  const [email, setEmail] = useState('');
  const [isReqSent, setIsReqSent] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (evt, isResend=false) => {
    evt.preventDefault();
    let payload = {
      email,
    };
    setIsloading(true);
    forgotPassword((res) => {
      const { success, error } = res;
      if (success === true) {
        setIsReqSent(true);
        if(isResend === true){
          ModalService.openAlert('', messages.COMMON.FORGOT_PASSWORD_INVITATION, 'success');
        }      
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  

  return (
    <Fragment>
      <div id='ForgotPassword'>
      {isLoading && <CustomSpinner />}
        <Row className='no-gutters h-100 main-row'>
          <Col lg='4' className=' bg-white powered-by'></Col>
          <Col
            lg='8'
            md='12'
            className=' d-flex bg-white justify-content-center align-items-center'
          >
            <hr className='vertical-line  bg-white' />
            <Col lg='8' md='8' sm='12' className='mx-auto app-login-box'>
              <div className='logo'>
                <img src={walkinImg} className='logo-img img-fluid' alt='' />
              </div>
              <div className='' />

              {!isReqSent ?
                (
                  <>
                    <h4>
                      <div>Recover your Password</div>
                      <span>Please enter your User ID and a reset link will be sent to your email address.</span>
                    </h4>
                    <div></div>
                    <Form onSubmit={(e) => handleSubmit(e,false)}>
                      <Row className='divider-width'>
                        <Col className='divider'></Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormGroup className='mb-0'>
                            <Label for='exampleEmail'>
                              Email<span className='required'>*</span>
                            </Label>
                            <Input
                              type='email'
                              onChange={(e) => setEmail(e.target.value)}
                              name='email'
                              required
                              id='exampleEmail'
                              placeholder='Email here...'
                              style={{marginBottom: '8px'}}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className='divider-width'>
                        <Col className='divider'></Col>
                      </Row>
                      <div className='mt-1 d-flex align-items-center btn-block'>
                        <h6 className='mb-0'>
                          <span
                            style={{ textDecoration: 'none', color: 'inherit' }}
                            className='btn-lg btn btn-link'
                            onClick={() => navigate('/user/login')}
                          >
                            Back to Login
                          </span>
                        </h6>
                        <Button
                          className='forgotpassword-btn'
                          style={{
                            borderRadius: '18px',
                            fontWeight: '600',
                            textAlign: 'center',
                          }}
                          size='lg'
                        >
                          Send Recovery Link
                        </Button>
                      </div>
                    </Form>
                  </>
                ) :
                (
                  <>
                    <div className='passwordText mt-3'>
                      <div>We have sent a password reset link to {email || " "}.</div>
                      <div>Please check your email.</div>
                      <div className='mt-2'>Didn't get the link? <span className="passwordLink textUnderline cursorPointer" onClick={(e) => handleSubmit(e,true)}>Resend</span></div>
                    </div>
                    <div className='mt-4 d-flex align-items-center btn-block'>
                      <h6 className='mb-0'>
                        <span
                          style={{ textDecoration: 'none', color: 'inherit' }}
                          className='btn-lg btn btn-link'
                          onClick={() => navigate('/user/login')}
                        >
                          Back to Login
                        </span>
                      </h6>
                    </div>
                  </>
                )
              }
            </Col>
          </Col>
        </Row>
      </div>
    </Fragment>
  );
};

export default ForgotPassword;
